// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiResultSearchBase {
    static getAttributeTypeMap() {
        return PharmacyBiResultSearchBase.attributeTypeMap;
    }
}
PharmacyBiResultSearchBase.discriminator = undefined;
PharmacyBiResultSearchBase.additionalProperties = false;
PharmacyBiResultSearchBase.attributeTypeMap = [
    {
        "name": "result",
        "baseName": "result",
        "type": "PharmacyBiResponse"
    },
    {
        "name": "clientId1",
        "baseName": "clientId1",
        "type": "string"
    },
    {
        "name": "clientId2",
        "baseName": "clientId2",
        "type": "string"
    },
    {
        "name": "clientId3",
        "baseName": "clientId3",
        "type": "string"
    },
    {
        "name": "clientId4",
        "baseName": "clientId4",
        "type": "string"
    },
    {
        "name": "clientId5",
        "baseName": "clientId5",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiResultSearchBase.js.map